var React = require('react');

function IcoExpand (props) {
    return React.createElement("svg",props,React.createElement("image",{"width":"14","height":"8","xlinkHref":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAICAMAAAD+zz7+AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAARVBMVEX///9Ci8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8pCi8oAAABsn33jAAAAFXRSTlMAA5OrD6XJ8eU3JOQc3A6AtIzt2LoG5cHbAAAAAWJLR0QWfNGoGQAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB+EDDg00I6cmfrIAAAA/SURBVAjXY2AAAUYmZhYGOGBkFRVlY0HisXPA+SAeJxc3lA/mMTDw8IL5UB6Ez8fAD+WB+QIMgkKcMCN5hEUAe3UCjts6EFoAAAAASUVORK5CYII="}));
}

IcoExpand.defaultProps = {"width":"14","height":"8","viewBox":"0 0 14 8"};

module.exports = IcoExpand;

IcoExpand.default = IcoExpand;
